var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-container',[_c('el-header',[_c('common-head',{on:{"mainKey":_vm.mainKey}})],1),_c('el-container',[_c('el-aside',[_c('common-aside')],1),_c('el-main',{key:_vm.mainNumber},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }